import {
    AdditionalInformationEnum,
    AdvertisementAnalysis,
    BuildingConditionEnum,
    BuildingOverallConditionEnum,
    FlatBuildingTypeEnum,
    PriceRangeResponseDto,
    PriceSearchValue,
    TypeOfMarketEnum,
    UserPredictionListItemDto,
    ValuationResultDto
} from './AiPredictorModels';
import { FlatsFilterDto } from './SaleModels';

export type { FlatsFilterDto };
export type SimilarFlatDto = Record<string, unknown>;
import { LocationItem, SavedLocationsType } from './V2Locations';

export interface ValuationFiltersStateType {
    locations: LocationItem[],
    savedLocations: SavedLocationsType,
    searchLocationResult: LocationItem[];
    buildingNumber: string;
    area: string,
    builtYear: string,
    numberOfRooms: number,
    buildingType: FlatBuildingTypeEnum,
    buildingCondition: BuildingConditionEnum,
    buildingOverallCondition: BuildingOverallConditionEnum.Dobry,
    floor: number,
    floors: number,
    typeOfMarket: TypeOfMarketEnum,
    locationId: number,
    description: string,
    additionalInfo: AdditionalInformationEnum[]
}

export interface SelectedPriceRangeType {
    minPricePerSquareMeter: number;
    maxPricePerSquareMeter: number;
    minPrice: number;
    maxPrice: number;
    priceSearchValue: PriceSearchValue;
}

export type ValuationStep = 1 | 2;

export interface ValuationStateType {
    isLoading: boolean;
    currentStep: ValuationStep;
    valuationResultV2?: ValuationResultDto;
    valuationAnalysis?: AdvertisementAnalysis;
    similarFlat?: SimilarFlatDto[];
    priceRangeResponse?: PriceRangeResponseDto;
    selectedPriceRange?: SelectedPriceRangeType;
    similarFlatsFilter?: FlatsFilterDto;
    savedReports: UserPredictionListItemDto[];
    selectedReportUuid: string | null;
}

export const filterValuationInitialState: ValuationFiltersStateType = {
    locations: [],
    savedLocations: {},
    buildingNumber: '',
    searchLocationResult: [],
    numberOfRooms: 0,
    area: '',
    builtYear: '',
    buildingType: FlatBuildingTypeEnum.Blok,
    buildingCondition: BuildingConditionEnum.DoRemontu,
    buildingOverallCondition: BuildingOverallConditionEnum.Dobry,
    floor: 0,
    floors: 0,
    typeOfMarket: TypeOfMarketEnum.Wtorny,
    locationId: 0,
    description: '',
    additionalInfo: []
};

// @todo: usunąć v2 po aktualizacji endpointów i zmienić nazwę bez v2
export const initialValuationState: ValuationStateType = {
    isLoading: false,
    currentStep: 1,
    valuationResultV2: undefined,
    valuationAnalysis: undefined,
    similarFlat: [],
    similarFlatsFilter: undefined,
    priceRangeResponse: undefined,
    selectedPriceRange: undefined,
    savedReports: [],
    selectedReportUuid: null
};
